import React, { useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Modal, ModalBody } from "reactstrap";
import { Redirect } from 'react-router-dom';
import { showNotification, successNofication } from "src/shared/components/Notification";
import PndRestApi from "src/utils/pnd/PndRestApi";
import ResetPassword from "./UpdateResetPassword";
import { ERROR_MESSAGES, PAGE_TIMEOUT } from "src/utils/pnd/PndConstants";
import LockResetIcon from '@mui/icons-material/LockReset';
import CloseIcon from '@mui/icons-material/Close';
import { CircularProgress } from '@mui/material';

const ModalPasswordResert = ({ modalShow, setModalShow, userData }) => {
  const [isRedirect, setIsRedirect] = useState(false);
  const [loading, setLoading] = useState(false);

  if (isRedirect) {
    window.location.reload();
    return <Redirect to="/web_app/user_management/rider/reset_password" />;
  }

  const toggle = () => {
    if (!loading) {
      setModalShow(prevState => !prevState);
    }
  }

  const handleSubmit = async (formValues) => {
    try {
      setLoading(true);

      let obj = {
        "password": formValues["password"],
        "riderId": formValues["riderId"]
      };

      const response = await PndRestApi.ChangeRiderPassword(obj);
      if (response.status === 200 && response.data.status === 200) {
        successNofication(
          "theme-light",
          "ltr",
          `SuccessCode: ${response.data.status}`,
          `Message: Rider Password Reset Successfully.`,
        );
        setTimeout(() => {
          setIsRedirect(true);
        }, PAGE_TIMEOUT);
      } else {
        showNotification(
          "theme-light",
          "ltr",
          `SuccessCode: ${response.data.status}`,
          `Message:${response.data.message}`,
        );
      }
    } catch (error) {
      showNotification(
        "theme-light",
        "ltr",
        `SuccessCode: 500`,
        ERROR_MESSAGES.tryCatchError,
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <Modal
        isOpen={modalShow}
        toggle={toggle}
        modalClassName="ltr-support"
        className="theme-light ltr-support"
        size="md"
        backdrop={loading ? "static" : true}
        style={{ maxWidth: '500px' }}
      >
        {/* Modern Modal Header */}
        <div
          className="position-relative"
          style={{
            background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)', // Vibrant pink-red gradient for security
            padding: '1.5rem 2rem',
            borderRadius: '0.5rem 0.5rem 0 0',
            boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
          }}
        >
          <div className="d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center">
              <div
                className="d-flex align-items-center justify-content-center me-3"
                style={{
                  width: '48px',
                  height: '48px',
                  background: 'rgba(255,255,255,0.2)',
                  borderRadius: '12px',
                  backdropFilter: 'blur(10px)'
                }}
              >
                <LockResetIcon style={{ fontSize: '28px', color: '#fff' }} />
              </div>
              <div>
                <h4
                  className="m-0 text-white fw-bold"
                  style={{
                    fontSize: '1.4rem',
                    letterSpacing: '0.5px',
                    textShadow: '0 2px 4px rgba(0,0,0,0.1)'
                  }}
                >
                  Reset Password
                </h4>
                <p className="m-0 text-white-50 small">
                  Securely update rider access password
                </p>
              </div>
            </div>
            <button
              type="button"
              onClick={toggle}
              disabled={loading}
              className="btn-close-custom"
              style={{
                background: 'rgba(255,255,255,0.2)',
                border: 'none',
                borderRadius: '50%',
                width: '36px',
                height: '36px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: loading ? 'not-allowed' : 'pointer',
                transition: 'all 0.3s ease',
                opacity: loading ? 0.5 : 1
              }}
              onMouseEnter={(e) => {
                if (!loading) {
                  e.currentTarget.style.background = 'rgba(255,255,255,0.3)';
                  e.currentTarget.style.transform = 'rotate(90deg)';
                }
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = 'rgba(255,255,255,0.2)';
                e.currentTarget.style.transform = 'rotate(0deg)';
              }}
            >
              <CloseIcon style={{ color: '#fff', fontSize: '20px' }} />
            </button>
          </div>
        </div>

        {/* Modal Body */}
        <ModalBody className="p-0" style={{ background: '#f8f9fa' }}>
          {loading && (
            <div
              className="position-absolute w-100 h-100 d-flex align-items-center justify-content-center"
              style={{
                background: 'rgba(255,255,255,0.85)',
                zIndex: 1050,
                backdropFilter: 'blur(4px)'
              }}
            >
              <div className="text-center">
                <CircularProgress size={45} style={{ color: '#f5576c' }} />
                <p className="mt-2 text-muted fw-bold small">Updating Password...</p>
              </div>
            </div>
          )}

          <div className="p-4">
            <ResetPassword userData={userData} onSubmit={handleSubmit} />
          </div>
        </ModalBody>
      </Modal>
    </div>
  );
};

ModalPasswordResert.propTypes = {
  modalShow: PropTypes.bool.isRequired,
  setModalShow: PropTypes.func.isRequired,
  userData: PropTypes.object,
};

export default connect((state) => ({
  rtl: state.rtl,
}))(ModalPasswordResert);
